// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Ji7oW","rootSmall":"AddTileButton_rootSmall__uOASq"};